export const getStorage = (...inputs) => {
  const storage_name = inputs[0]
  const storage_mode = inputs.length >= 5 ? inputs[1] : "memory"

  let result
  if(storage_mode === "memory"){
    try{
      return State.get(storage_name)
    }catch(error){
      return null
    }
  }
  if(storage_mode === "session"){
    try{
      result = JSON.parse(sessionStorage.getItem(storage_name))
    }catch(error){
      result = sessionStorage.getItem(storage_name)
    }
    // console.log("getStorage", storage_name, storage_mode, result);
    return result
  }
  if(storage_mode === "local"){
    try{
      result = JSON.parse(localStorage.getItem(storage_name))
    }catch(error){
      result = localStorage.getItem(storage_name)
    }
    // console.log("getStorage", storage_name, storage_mode, result);
    return result
  }
  return null;
}

export const setStorage = (...inputs) => {
  const storage_name = inputs[0]
  const storage_value = inputs[1]
  const storage_mode = inputs.length >= 6 ? inputs[2] : "memory"

  if(storage_mode === "memory"){
    State.set(storage_name, storage_value);
    // console.log("setStorage", storage_name, storage_mode, storage_value);
    return storage_value
  }
  if(storage_mode === "session"){
    sessionStorage.setItem(storage_name, JSON.stringify(storage_value))
    // console.log("setStorage", storage_name, storage_mode, storage_value);
    return storage_value
  }
  if(storage_mode === "local"){
    localStorage.setItem(storage_name, JSON.stringify(storage_value))
    // console.log("setStorage", storage_name, storage_mode, storage_value);
    return storage_value
  }
  return null;
}

export const removeStorage = (...inputs) => {
  const storage_name = inputs[0]
  const storage_mode = inputs.length >= 5 ? inputs[1] : "memory"

  if(storage_mode === "memory"){
    State.remove(storage_name)
    // console.log("removeStorage", storage_name, storage_mode);
  }
  if(storage_mode === "session"){
    sessionStorage.removeItem(storage_name)
    // console.log("removeStorage", storage_name, storage_mode);
  }
  if(storage_mode === "local"){
    localStorage.removeItem(storage_name)
    // console.log("removeStorage", storage_name, storage_mode);
  }
}

export const clearStorage = (...inputs) => {
  const storage_mode = inputs.length >= 4 ? inputs[0] : "session"

  if(storage_mode === "session"){
    sessionStorage.clear()
    // console.log("clearStorage", storage_mode);
  }
  if(storage_mode === "local"){
    localStorage.clear()
    // console.log("clearStorage", storage_mode);
  }
}

export const subscribeStorage = (...inputs) => {
  const storage_name = inputs[0]
  const storage_func = inputs[1]
  const storage_mode = inputs.length >= 6 ? inputs[2] : "memory"

  if(storage_mode === "memory"){
    State.subscribe(storage_name, storage_func);
  }
  if(storage_mode === "session"){
    console.log("subscribe only available for memory.");
  }
  if(storage_mode === "local"){
    console.log("subscribe only available for memory.");
  }
}

export const unsubscribeStorage = (...inputs) => {
  const storage_name = inputs[0]
  const storage_func = inputs[1]
  const storage_mode = inputs.length >= 6 ? inputs[2] : "memory"

  if(storage_mode === "memory"){
    State.unsubscribe(storage_name, storage_func);
  }
  if(storage_mode === "session"){
    console.log("subscribe only available for memory.");
  }
  if(storage_mode === "local"){
    console.log("subscribe only available for memory.");
  }
}

const createStateManager = () => {
  const state = new Map();
  const subscribers = new Map();

  const get = (key) => state.get(key);

  const set = (key, value) => {
    const oldValue = state.get(key);
    state.set(key, value);
    if (oldValue !== value && subscribers.has(key)) {
      subscribers.get(key).forEach(fn => fn(value, oldValue));
    }
  };

  const subscribe = (key, fn) => {
    if (!subscribers.has(key)) {
      subscribers.set(key, new Set());
    }
    subscribers.get(key).add(fn);
  };

  const unsubscribe = (key, fn) => {
    if (subscribers.has(key)) {
      subscribers.get(key).delete(fn);
      if (subscribers.get(key).size === 0) {
        subscribers.delete(key);
      }
    }
  };

  const remove = (key) => {
    state.delete(key);
    subscribers.delete(key);
  };

  const has = (key) => state.has(key);

  return {
    get,
    set,
    subscribe,
    unsubscribe,
    remove,
    has,
  };
};

const State = createStateManager();